import { PageReporting } from './Overview';
import { PageReportingView } from './View';
import { PageReportingSchedule } from './Schedule';

export const REPORTING = {
  Reporting: PageReporting,
  ReportingView: PageReportingView,
  ReportingSchedule: PageReportingSchedule,
} as const;
